/* ============================================================
   Mybibblio — product-page description "Read more" (mobile)
   The description keeps its exact content and styling; on mobile
   it is clamped by CSS and this script adds the toggle button.
   Open/closed state lives on <html> (html.mb-desc-open) so it
   survives the section re-render that variant changes trigger;
   the MutationObserver re-inserts the button after those renders.
   ============================================================ */
(function () {
  function descEl() {
    return document.querySelector('main[data-template="product"] rte-formatter[class*="__desc"]');
  }

  function isOpen() {
    return document.documentElement.classList.contains('mb-desc-open');
  }

  function sync(btn) {
    var label = isOpen() ? 'Read less ▴' : 'Read more ▾';
    if (btn.textContent !== label) btn.textContent = label;
    var expanded = isOpen() ? 'true' : 'false';
    if (btn.getAttribute('aria-expanded') !== expanded) btn.setAttribute('aria-expanded', expanded);
  }

  function ensure() {
    var d = descEl();
    if (!d) return;
    var next = d.nextElementSibling;
    if (next && next.classList && next.classList.contains('kb-desc-more')) {
      sync(next);
      return;
    }
    // only offer the toggle when there is enough text to be worth folding
    if ((d.textContent || '').trim().length < 400) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kb-desc-more';
    btn.setAttribute('data-kb-desc-toggle', '');
    sync(btn);
    d.insertAdjacentElement('afterend', btn);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-kb-desc-toggle]');
    if (!btn) return;
    document.documentElement.classList.toggle('mb-desc-open');
    sync(btn);
    if (!isOpen()) {
      var d = descEl();
      if (d) {
        var r = d.getBoundingClientRect();
        if (r.top < 0) {
          try { d.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (err) { d.scrollIntoView(); }
        }
      }
    }
  });

  var t = null;
  var mo = new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(ensure, 150);
  });

  function boot() {
    ensure();
    var host = document.querySelector('main');
    if (host) mo.observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
